import React, { forwardRef, useState, useImperativeHandle, useEffect } from "react";
import { default as ReactSelect } from "react-select";

const SelectList = forwardRef( 
    function SelectList({
        label, options=[{}], defaultValues, placeholder, callbackOnChange, isRequired, isMulti=false
        }, 
        ref
    ) {
    const [optionsSelected, setOptionsSelected] = useState(null);
    const [isDisplayErrors, setIsDisplayErrors] = useState(false);

    useEffect(() => {
        setOptionsSelected(defaultValues);
    }, [defaultValues]);

    useImperativeHandle(ref, ()=>({
        getValue() {
            let valuesList = null;

            // Return only the values without label (generally the ids)
            if (Array.isArray(optionsSelected))
                valuesList = optionsSelected.map(option => option.value);
            else     
                valuesList = optionsSelected?.value;

            return valuesList;
        },
        resetValue() {
            setOptionsSelected([]);
            setPicto(null);   
            setIsDisplayErrors(false);         
        },
        hasErrors() {
            return hasErrors();
        },
        displayErrors() {
            setIsDisplayErrors(false)
            if (hasErrors()) {
                setIsDisplayErrors(true)
            }
        }
    }))

    /**
     * Check if there is an error in this input
     */
    function hasErrors() {
        if (Array.isArray(optionsSelected))
            return (isRequired && optionsSelected.length == 0);
        else
            return (isRequired && !optionsSelected);
    }

    function displayErrorMessage() {
        if (isDisplayErrors) {
            return (
                <p className="input-error-message">Ce champ est obligatoire</p>
            )
        }
    }

    const handleChange = (selected) => {
        setOptionsSelected(selected);

        if (callbackOnChange)
            callbackOnChange(selected);
    };    

    let mandatoryMark = isRequired ? "(obligatoire)" : "";

    function selectBackgroundColor(state) {
        if (state.isFocused || state.isSelected)
            return "#E3E8EF";
            
        return "white";
    }

    const customFormatOptionLabel = ({ label, icon }) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {icon}
            {label}
        </div>
    );

    function displayLabel() {
        if (label)
            return (<label className="form-label selectlist-label">{label} {mandatoryMark}</label>);
    }
    
    return (
        <div className="input-selectlist">
            {displayLabel()}            
            <ReactSelect
                options={options}
                closeMenuOnSelect={!isMulti}
                hideSelectedOptions={false}
                onChange={handleChange}
                value={optionsSelected}
                isMulti={isMulti}
                placeholder={placeholder}
                formatOptionLabel={customFormatOptionLabel}
                menuPortalTarget={document.body}
                styles={{
                    control: (baseStyles, state) => ({
                        ...baseStyles,
                        border: "1px solid #E3E8EF"
                    }),
                    option: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: selectBackgroundColor(state),
                        color: "#030816",
                    }),
                    menu: (baseStyles, state) => ({
                        ...baseStyles,
                        padding: "10px",
                        border: "1px solid #E3E8EF"
                    })
                }}
                
            />
            {displayErrorMessage()}
        </div>
    );
})

export default SelectList;